import { useEffect } from 'react';

/** html 에 붙는 동안 `.u-slide` 가 스크롤 멈춤 지점이 된다 — 규칙은 global.css 에 있다 */
export const SNAP_PAGE_CLASS = 'u-snap-page';

/**
 * 이 페이지에 머무는 동안만 스크롤을 슬라이드처럼 끊는다(PPT 넘김).
 *
 * 스크롤 컨테이너가 문서 자체(html)라서 페이지 컴포넌트에 걸 수 없다 — 들어올 때 붙이고
 * 나갈 때 떼어, 다른 화면의 스크롤에는 번지지 않게 한다.
 * 실제로 끊는 것은 CSS 다(넓은 화면에서만). 여기서는 스위치만 켠다.
 */
export function useSlideSnap(): void {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add(SNAP_PAGE_CLASS);
    return () => root.classList.remove(SNAP_PAGE_CLASS);
  }, []);
}
